<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/accounting/tax-invoice">
                    <icon name="file-invoice"></icon>
                    &nbsp;ใบกำกับภาษี-การขาย
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/accounting/tax-payment">
                    <icon name="file-invoice"></icon>
                    &nbsp;ใบกำกับภาษีซื้อ
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/accounting/tax-payment-account">
                    <icon name="file-invoice"></icon>
                    &nbsp;รหัสบัญชีสำหรับภาษีซื้อ
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/accounting/billing-RE">
                    <icon name="file-invoice-dollar"></icon>
                    &nbsp;ใบเสร็จรับเงิน
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/accounting/credit-note">
                    <icon name="file-invoice-dollar"></icon>
                    &nbsp;ใบลดหนี้
                </b-nav-item>&nbsp;
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "tax-invoice-layout"
    }
</script>

<style scoped>

</style>
